interface CssKeyValue{
    key:string,
    value:string
}
const getKeyValues=(data:Array<CssKeyValue>)=>{
    let result=''
    for(let i=0;i<data.length;i++){
        result+=createStyle(data[i])
    }
    return result
}
const createStyle=(value:CssKeyValue)=>{
    return value.key+' : '+value.value+';'
}
const getBackgroundImage=(url:string)=>{
    //let result='url("images/#")'
    //result=result.replace('#',url)
    return {key:'background-image',value:createCSSBackgroundImage(url)}
}
const createCSSBackgroundImage=(url:string)=>{
    let result='url("images/#")'
    result=result.replace('#',url)
    return result
}
const getStringFromCode=(code:number)=>{
    const decoder = '①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱'
    return decoder.charAt(code)
}
export {
    CssKeyValue,
    getKeyValues,
    createStyle,
    getBackgroundImage,
    getStringFromCode
}